module.exports = {"name":"showApiErrors","audiences":["allMembers"],"experimentAllocation":0,"defaultWeight":1,"experimentVersion":"v1","defaults":{"enabled":false},"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/showApiErrors.json
// module id = 4zlB
// module chunks = 0